import { render, staticRenderFns } from "./TheSnapshotMoveAndCopyFiles.vue?vue&type=template&id=5554670e&"
import script from "./TheSnapshotMoveAndCopyFiles.vue?vue&type=script&lang=js&"
export * from "./TheSnapshotMoveAndCopyFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports